import { render, staticRenderFns } from "./ExtensionOptionEvent.vue?vue&type=template&id=0aca23ef&"
import script from "./ExtensionOptionEvent.vue?vue&type=script&lang=js&"
export * from "./ExtensionOptionEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports